import { MemberInquirer } from './MemberInquirer';

export default MemberInquirer;